<div class="cockpit-content">
  <h1 class="-default-layout">{{card.title | translate}}</h1>
  <div class="cockpit-view">
    <div class="pdt-20">
      <div class="table-container">
        <h4>
          {{tableHeaders[0] | translate}}
        </h4>

        <app-chart-download-button
          (buttonClick)="exportTable('drchschnittswerteErklärungsmerkmale', 0)">
          <h5>{{ 'sprint9.cockpit.card.all.tabelle' | translate }}</h5>
        </app-chart-download-button>

        <div class="table-wrapper pdb-30">
          <table id="drchschnittswerteErklärungsmerkmale">
            <tr>
              <td class="no-border"></td>
              <th scope="col" class="header centered bold border-bold-left border-bold-right">{{ 'i18n.common.maenner' | translate }} </th>
              <th scope="col" class="header centered bold border-bold-left border-bold-right">{{ 'i18n.common.frauen' | translate }} </th>
            </tr>

            <tr>
              <td class="header centered bold border-bold-left border-bold-right">
                &nbsp;
              </td>
              <td class="border-bold-right centered"><small>(N =
              {{ personenStellenbezogeneMerkmale.totalMaennerAnzahl | numberFormat: crtLocale }})</small></td>
              <td class="border-bold-right centered"><small>(N =
              {{ personenStellenbezogeneMerkmale.totalFrauenAnzahl | numberFormat: crtLocale }})</small></td>
            </tr>
            <tr class="content">
              <th scope="row" class="border-bold-left border-bold-right">
                {{'i18n.cockpit.card.chart.personenStellenbezogeneMerkmale.alterInJahren' | translate }}
              </th>
              <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.alterMaenner | number: '1.1-1' }}</td>
              <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.alterFrauen | number: '1.1-1' }}</td>
            </tr>

            <tr class="content">
              <th scope="row" class="border-bold-left border-bold-right">
                {{'i18n.cockpit.card.chart.personenStellenbezogeneMerkmale.ausbildungsjahre' | translate }}
              </th>
              <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.ausbildungsjahreMaenner | number: '1.1-1' }}</td>
              <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.ausbildungsjahreFrauen | number: '1.1-1' }}</td>
            </tr>

            <tr class="content">
              <th scope="row" class="border-bold-left border-bold-right">
                {{'i18n.cockpit.card.chart.personenStellenbezogeneMerkmale.erwerbsjahrePotenziell' | translate }}
              </th>
              <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.erwerbsjahreMaenner | number: '1.1-1' }}</td>
              <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.erwerbsjahreFrauen | number: '1.1-1' }}</td>
            </tr>

            <tr class="content">
              <th scope="row" class="border-bold-left border-bold-right">
                {{'i18n.cockpit.card.chart.personenStellenbezogeneMerkmale.dienstjahre' | translate }}
              </th>
              <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.dienstjahreMaenner | number: '1.1-1' }}</td>
              <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.dienstjahreFrauen | number: '1.1-1' }}</td>
            </tr>
            <tr class="hint">
              <td class="hint" colspan="3">{{'m1.sprint10.cockpit.card.personenStellenbezogeneMerkmale.hinveise-grundgesamtheit-gueltig' | translate}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div class="table-container pdb-30">
      <h4>{{tableHeaders[1] | translate}}</h4>

      <!-- table 2 -->
      <app-chart-download-button
        (buttonClick)="exportTable('anteileErklärungsmerkmale', 1)">
        <h5>{{ 'sprint9.cockpit.card.all.tabelle' | translate }}</h5>
      </app-chart-download-button>

      <div class="table-wrapper">
        <table id="anteileErklärungsmerkmale">
          <tr>
            <td class="no-border"></td>
            <th scope="colgroup" colspan="2" class="header centered bold border-bold-left border-bold-right">{{ 'i18n.common.maenner' | translate }} </th>
            <th scope="colgroup" colspan="2" class="header centered bold border-bold-left border-bold-right">{{ 'i18n.common.frauen' | translate }} </th>
          </tr>

          <tr>
            <th scope="col" class="header centered bold border-bold-left border-bold-right">
              {{'i18n.cockpit.card.chart.personenStellenbezogeneMerkmale.kompetezniveau' | translate }}
            </th>
            <th scope="col" class="centered">{{ 'i18n.common.anzahl' | translate }}</th>
            <th scope="col" class="centered border-bold-right">{{ 'i18n.common.anteile' | translate }}</th>
            <th scope="col" class="centered">{{ 'i18n.common.anzahl' | translate }}</th>
            <th scope="col" class="centered border-bold-right">{{ 'i18n.common.anteile' | translate }}</th>
          </tr>

          <tr class="content">
            <th scope="row" class="border-bold-left border-bold-right">
              {{'i18n.cockpit.card.chart.personenStellenbezogeneMerkmale.anf.1' |
              translate }}
            </th>
            <td>{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau1MaennerAnzahl | numberFormat: crtLocale }}</td>
            <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau1MaennerAnteil }}
            </td>
            <td>{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau1FrauenAnzahl | numberFormat: crtLocale }}</td>
            <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau1FrauenAnteil }}
            </td>
          </tr>

          <tr class="content">
            <th scope="row" class="border-bold-left border-bold-right">
              {{'i18n.cockpit.card.chart.personenStellenbezogeneMerkmale.anf.2' |
              translate }}
            </th>
            <td>{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau2MaennerAnzahl | numberFormat: crtLocale }}</td>
            <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau2MaennerAnteil }}
            </td>
            <td>{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau2FrauenAnzahl | numberFormat: crtLocale }}</td>
            <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau2FrauenAnteil }}
            </td>
          </tr>

          <tr class="content">
            <th scope="row" class="border-bold-left border-bold-right">
              {{'i18n.cockpit.card.chart.personenStellenbezogeneMerkmale.anf.3' | translate }}
            </th>
            <td>{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau3MaennerAnzahl | numberFormat: crtLocale }}</td>
            <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau3MaennerAnteil }}
            </td>
            <td>{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau3FrauenAnzahl | numberFormat: crtLocale }}</td>
            <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau3FrauenAnteil }}
            </td>
          </tr>
          <tr class="content">
            <th scope="row" class="border-bold-left border-bold-right">
              {{'i18n.cockpit.card.chart.personenStellenbezogeneMerkmale.anf.4' | translate }}
            </th>
            <td>{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau4MaennerAnzahl | numberFormat: crtLocale }}</td>
            <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau4MaennerAnteil }}
            </td>
            <td>{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau4FrauenAnzahl | numberFormat: crtLocale }}</td>
            <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau4FrauenAnteil }}
            </td>
          </tr>
          @if (isAllAnf) {
            <tr class="content">
              <th scope="row" class="border-bold-left border-bold-right">
                {{'i18n.cockpit.card.chart.personenStellenbezogeneMerkmale.anf.5' | translate }}
              </th>
              <td>{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau5MaennerAnzahl | numberFormat: crtLocale }}</td>
              <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau5MaennerAnteil }}
              </td>
              <td>{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau5FrauenAnzahl | numberFormat: crtLocale }}</td>
              <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau5FrauenAnteil }}
              </td>
            </tr>
          }
          @if (isAllAnf) {
            <tr class="content">
              <th scope="row" class="border-bold-left border-bold-right">
                {{'i18n.cockpit.card.chart.personenStellenbezogeneMerkmale.anf.6' | translate }}
              </th>
              <td>{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau6MaennerAnzahl | numberFormat: crtLocale }}</td>
              <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau6MaennerAnteil }}
              </td>
              <td>{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau6FrauenAnzahl | numberFormat: crtLocale }}</td>
              <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau6FrauenAnteil }}
              </td>
            </tr>
          }
          @if (isAllAnf) {
            <tr class="content">
              <th scope="row" class="border-bold-left border-bold-right">
                {{'i18n.cockpit.card.chart.personenStellenbezogeneMerkmale.anf.7' | translate }}
              </th>
              <td>{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau7MaennerAnzahl | numberFormat: crtLocale }}</td>
              <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau7MaennerAnteil }}
              </td>
              <td>{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau7FrauenAnzahl | numberFormat: crtLocale }}</td>
              <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau7FrauenAnteil }}
              </td>
            </tr>
          }
          @if (isAllAnf) {
            <tr class="content">
              <th scope="row" class="border-bold-left border-bold-right">
                {{'i18n.cockpit.card.chart.personenStellenbezogeneMerkmale.anf.8' | translate }}
              </th>
              <td>{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau8MaennerAnzahl | numberFormat: crtLocale }}</td>
              <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau8MaennerAnteil }}
              </td>
              <td>{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau8FrauenAnzahl | numberFormat: crtLocale }}</td>
              <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.betrieblichesKompetenzniveau8FrauenAnteil }}
              </td>
            </tr>
          }
          <tr class="content">
            <th scope="row" class="border-bold-left border-bold-right border-bold-top">
              {{'i18n.common.total' | translate }}
            </th>
            <td class="border-bold-top">{{ personenStellenbezogeneMerkmale.totalMaennerAnzahl }}</td>
            <td class="border-bold-right border-bold-top">{{ personenStellenbezogeneMerkmale.totalMaennerAnteil }}</td>
            <td class="border-bold-top">{{ personenStellenbezogeneMerkmale.totalFrauenAnzahl }}</td>
            <td class="border-bold-right border-bold-top">{{ personenStellenbezogeneMerkmale.totalFrauenAnteil }}</td>
          </tr>
          <tr class="hint">
            <td class="hint" colspan="5">{{'i18n.cockpit.card.hinveise-grundgesamtheit-gueltig' | translate}}
            {{ (isAllAnf ? 'i18n.cockpit.card.hinveise-grundgesamtheit-gueltig.anf8' : 'i18n.cockpit.card.hinveise-grundgesamtheit-gueltig.anf4') | translate }}</td>
          </tr>
        </table>
      </div>
    </div>

    <app-chart-kompetenzniveau id="cmptChartKompetenzniveau" [seriesAnzahlMitarbeitend]="seriesKompetenzniveau"
    class="cockpit-svg-image"></app-chart-kompetenzniveau>


    <div class="table-container">
      <h4>{{ tableHeaders[2] | translate}}</h4>

      <app-chart-download-button
        (buttonClick)="exportTable('beruflicheStellung', 2)">
        <h5>{{ 'sprint9.cockpit.card.all.tabelle' | translate }}</h5>
      </app-chart-download-button>

      <div class="table-wrapper pdb-30">
        <!-- table 3 -->
        <table id="beruflicheStellung">
          <tr>
            <td class="no-border"></td>
            <th scope="colgroup" colspan="2" class="header centered bold border-bold-left border-bold-right">{{ 'i18n.common.maenner' | translate }} </th>
            <th scope="colgroup" colspan="2" class="header centered bold border-bold-left border-bold-right">{{ 'i18n.common.frauen' | translate }} </th>
          </tr>

          <tr>
            <th scope="col" class="header centered bold border-bold-left border-bold-right border-bold-left border-bold-right">
              {{'i18n.cockpit.card.chart.personenStellenbezogeneMerkmale.beruflicheStellung' | translate }}
            </th>
            <th scope="col" class="centered">{{ 'i18n.common.anzahl' | translate }}</th>
            <th scope="col" class="centered border-bold-right">{{ 'i18n.common.anteile' | translate }}</th>
            <th scope="col" class="centered">{{ 'i18n.common.anzahl' | translate }}</th>
            <th scope="col" class="centered border-bold-right">{{ 'i18n.common.anteile' | translate }}</th>
          </tr>

          <tr class="content">
            <th scope="row" class="border-bold-left border-bold-right">
              {{'i18n.cockpit.card.chart.personenStellenbezogeneMerkmale.1OberesKader' | translate }}
            </th>
            <td>{{ personenStellenbezogeneMerkmale.beruflicheStellung1MaennerAnzahl}}</td>
            <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.beruflicheStellung1MaennerAnteil}}</td>
            <td>{{ personenStellenbezogeneMerkmale.beruflicheStellung1FrauenAnzahl}}</td>
            <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.beruflicheStellung1FrauenAnteil}}</td>
          </tr>

          <tr class="content">
            <th scope="row" class="border-bold-left border-bold-right">
              {{'i18n.cockpit.card.chart.personenStellenbezogeneMerkmale.2MittleresKader' | translate }}
            </th>
            <td>{{ personenStellenbezogeneMerkmale.beruflicheStellung2MaennerAnzahl}}</td>
            <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.beruflicheStellung2MaennerAnteil}}</td>
            <td>{{ personenStellenbezogeneMerkmale.beruflicheStellung2FrauenAnzahl}}</td>
            <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.beruflicheStellung2FrauenAnteil}}</td>
          </tr>

          <tr class="content">
            <th scope="row" class="border-bold-left border-bold-right">
              {{'i18n.cockpit.card.chart.personenStellenbezogeneMerkmale.3UnteresKader' | translate }}
            </th>
            <td>{{ personenStellenbezogeneMerkmale.beruflicheStellung3MaennerAnzahl}}</td>
            <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.beruflicheStellung3MaennerAnteil}}</td>
            <td>{{ personenStellenbezogeneMerkmale.beruflicheStellung3FrauenAnzahl}}</td>
            <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.beruflicheStellung3FrauenAnteil}}</td>
          </tr>

          <tr class="content">
            <th scope="row" class="border-bold-left border-bold-right">
              {{'i18n.cockpit.card.chart.personenStellenbezogeneMerkmale.4UnteresKader' | translate }}
            </th>
            <td>{{ personenStellenbezogeneMerkmale.beruflicheStellung4MaennerAnzahl}}</td>
            <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.beruflicheStellung4MaennerAnteil}}</td>
            <td>{{ personenStellenbezogeneMerkmale.beruflicheStellung4FrauenAnzahl}}</td>
            <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.beruflicheStellung4FrauenAnteil}}</td>
          </tr>

          <tr class="content">
            <th scope="row" class="border-bold-left border-bold-right">
              {{'i18n.cockpit.card.chart.personenStellenbezogeneMerkmale.5OhneKaderfunktion' | translate }}
            </th>
            <td>{{ personenStellenbezogeneMerkmale.beruflicheStellung5MaennerAnzahl}}</td>
            <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.beruflicheStellung5MaennerAnteil}}</td>
            <td>{{ personenStellenbezogeneMerkmale.beruflicheStellung5FrauenAnzahl}}</td>
            <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.beruflicheStellung5FrauenAnteil}}</td>
          </tr>

          <tr class="primary content">
            <th scope="row" class="border-bold-left border-bold-right border-bold-top">
              {{'i18n.common.total' | translate }}
            </th>
            <td class="border-bold-top">{{ personenStellenbezogeneMerkmale.totalMaennerAnzahl}}</td>
            <td class="border-bold-right border-bold-top">{{ personenStellenbezogeneMerkmale.totalMaennerAnteil}}</td>
            <td class="border-bold-top">{{ personenStellenbezogeneMerkmale.totalFrauenAnzahl}}</td>
            <td class="border-bold-right border-bold-top">{{ personenStellenbezogeneMerkmale.totalFrauenAnteil}}</td>
          </tr>
          <tr class="hint">
            <td class="hint" colspan="5">{{'i18n.cockpit.card.hinveise-grundgesamtheit-gueltig' | translate}}</td>
          </tr>
        </table>
      </div>

      <div class="-wrap-margin">
        <app-chart-beruflicher-stellung id="cmptChartBeruflicherStellung"
          [seriesBeruflicherStellung]="seriesBeruflicheStellung" class="cockpit-svg-image">
        </app-chart-beruflicher-stellung>
      </div>
    </div>
  </div>
</div>
